import React from "react";
import { connect } from 'redux-bundler-react';
import classnames from "classnames";
import DatasetInfo from './dataset-info-modal';
import isEmpty from 'lodash/isEmpty';

class TreeListItemDataset extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: props.item.visible,
      displayName: props.item.displayName,
      type: props.item.type,
      expanded: false,
      source: props.item.mapLayer.getSource(),
      isLoading: false,
      loadingCount: 0,
      loadedCount: 0,
      percentage: 0
    };
    this.toggleVisible = this.toggleVisible.bind(this);
    this.zoomTo = this.zoomTo.bind(this);
    this.addLoading = this.addLoading.bind(this);
    this.addLoaded = this.addLoaded.bind(this);
    this.update = this.update.bind(this);
    this.removeListener = this.removeListener.bind(this);
    this.addListener = this.addListener.bind(this);
  }
  componentDidMount () {
    this.addListener();    
  } 
  addListener () {
    const { source } = this.state;
    const sourceName = source.constructor.name;
    if(sourceName !== 'VectorSource') {
      let sourceType = 'tile';
      switch(sourceName) {
        case 'XYZ':
          sourceType = 'tile';
          break;
        case 'ImageWMS':
          sourceType ='image';
          break;
        default:
          break;
      }
      const layerStart = sourceType+'loadstart'; 
      const layerEnd = sourceType+'loadend';
      const layerError = sourceType+'loaderror';

      source.on(layerStart, this.addLoading);
      source.on(layerEnd, this.addLoaded);
      source.on(layerError, this.addLoaded);
    }
  }
  removeListener () {
    const { source } = this.state;
    const sourceName = source.constructor.name;
    if(sourceName !== 'VectorSource') {
      let sourceType = 'tile';
      switch(sourceName) {
        case 'XYZ':
          sourceType = 'tile';
          break;
        case 'ImageWMS':
          sourceType ='image';
          break;
        default:
          break;
      }
      const layerStart = sourceType+'loadstart'; 
      const layerEnd = sourceType+'loadend';
      const layerError = sourceType+'loaderror';

      source.un(layerStart, this.addLoading);
      source.un(layerEnd, this.addLoaded);
      source.un(layerError, this.addLoaded);
    }
    this.setState({isLoading:false, loadingCount:0, loadedCount:0, percentage:0})
  }

  componentWillUnmount () {
    this.removeListener()
  }
  addLoading(){
    if(parseInt(this.state.loadingCount) === 0){
      this.setState({isLoading: true});
    }
    var count = parseInt(this.state.loadingCount) + 1;
    this.setState({loadingCount: count});
    this.update();
  }
  addLoaded(){ 
    if(this.state.isLoading === true){
      var count = parseInt(this.state.loadedCount) + 1;
      this.setState({loadedCount: count});
      this.update();     
    }
  }
  update() {
    const calculation = this.state.loadedCount/this.state.loadingCount;
    var percentage = (calculation*100).toFixed();
    this.setState({percentage: percentage});
    if(this.state.loadingCount === this.state.loadedCount){
      this.setState({
        loadingCount: 0,
        loadedCount: 0,
        isLoading: false,
        percentage: 0
      });
    }
  }

  toggleVisible() {
    const { item, doLayerSetVisible } = this.props;
    if(!item.visible) {
      this.addListener();
    }else{
      this.removeListener();      
    }
    
    doLayerSetVisible(item.uid, !item.visible);
  }

  toggleExpanded = () => {
    const { doOpenLayerDetails, item } = this.props;
    doOpenLayerDetails(item);
  };

  zoomTo(){
    const { item, doZoomToLayerExtent } = this.props;
    doZoomToLayerExtent(item.uid);
  };


  render() {
    const { item, isOver, theme} = this.props;
    const { isLoading, percentage, expanded } = this.state;
    const { displayName, type } = item;
    const itemClass = classnames({
      "checkbox-inline": true,
      "tree-list-item-hover": isOver
    });
    const iconClass = classnames({
      mdi: true,
      "mdi-map-marker": type === "POINT",
      "mdi-vector-line": type === "LINE",
      "mdi-vector-polygon": type === "POLYGON",
      "mdi-grid": type === "RASTER",
      "mdi-google-maps": type === "SERVICE"
    });
    const expanderClass = classnames({
      [theme]: expanded,
      "layertree-layeritem-detailsicon": true,
      expanded: expanded
    });
    const percentageTxt = percentage + "%";
    const showPercentage = isLoading ? 'percentage-style' : 'hide-percentage';
    return (
      <div className="layertree-layeritem">
        {/* <span className="pull-right">
          <span onClick={this.toggleExpanded} className={expanderClass}>
            <i className="mdi mdi-dots-horizontal" title="More Info" />
          </span>
        </span> */}
        <span
          onClick={this.zoomTo}
          className=""
          title="Zoom to Layer"
          style={{ marginRight: "10px" }}
        >
          <i className={iconClass} />
        </span>
        <span className={showPercentage}>{percentageTxt}</span>
        <label className={itemClass} title={displayName} style={{overflowWrap: 'break-word',whiteSpace: 'pre-wrap'}}>
          <input
            type="checkbox"
            checked={item.visible}
            value={item.visible}
            onChange={this.toggleVisible}
          />
          {displayName}
        </label>
        <span onClick={this.toggleExpanded} className={expanderClass}>
            <i className="mdi mdi-dots-horizontal" title="More Info" />
          </span>
      </div>
    );
  }
}

export default connect(
  'selectTheme',
  'doLayerSetVisible',
  'doTreeUpdate',
  'doZoomToLayerExtent',
  'doOpenLayerDetails',
  'doOpenModalWindow',
  TreeListItemDataset
);
